/* eslint-disable react/jsx-filename-extension */
import React from 'react';

export const SHADOW_ID = 'chart_shadow';
export const GRADIENT_ID = 'chart_gradient';

export const getLineShadow = () => (
  <filter id={SHADOW_ID} x="0" y="0" width="200%" height="200%">
    <feOffset result="offOut" in="SourceGraphic" dx="0" dy="0" />
    <feGaussianBlur result="blurOut" in="offOut" stdDeviation="2" />
    <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
  </filter>
);

export const getLineGradient = color => (
  <linearGradient id={GRADIENT_ID} x1="0%" y1="0%" x2="85%" y2="0%">
    <stop
      offset="0%"
      style={{
        stopColor: color,
        stopOpacity: '0.15'
      }}
    />
    <stop
      offset="100%"
      style={{
        stopColor: color,
        stopOpacity: '1'
      }}
    />
  </linearGradient>
);
